import fetch from "@/uilts/request";


// 深圳风控报告
export default {
    


    /**
     * 获取风控结果
     */

    async diTingQuery(data){
        return await fetch.post("ZhiCha/diTingQuery", data)
    },

    async zhiMiQuery(data){
        return await fetch.post("ZhiCha/zhiMiQuery", data)
    }

}
